import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { Loader, SpacerVertical } from '@klarna/bubble-ui';
import { Column } from 'moet-core';

import { ContainerTemplate, withReCaptchaProtectedCapability } from '@/components';
import { CAPS } from '@/constants';
import { getSetupData } from '@/selectors/data';

const SignupGateway = ({ postLead, recaptchaReady, setupData, onNext }) => {
  useEffect(() => {
    if (recaptchaReady) {
      if (setupData?.email) {
        postLead({ body: setupData }, onNext);
      } else {
        onNext();
      }
    }
  }, [setupData, recaptchaReady]);

  return (
    <ContainerTemplate showRecaptchaFooter>
      <Column alignItems="center">
        <SpacerVertical spaceToken="space/1000" />
        <Loader />
      </Column>
    </ContainerTemplate>
  );
};

SignupGateway.propTypes = {
  postLead: PropTypes.func.isRequired,
  recaptchaReady: PropTypes.bool.isRequired,
  setupData: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
};

export default compose(
  connect(state => ({
    setupData: getSetupData(state),
  })),
  withReCaptchaProtectedCapability({ postLead: CAPS.LEAD_POST }),
)(SignupGateway);
